__webpack_require__.p = "/pokedex_react/";